import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  orderNo: '',
  goodsName: '',
  consumerName: '',
  phoneNumber: '',
  nickname: '',
  placePlatform: '',
  orderStatus: 2,
  orderTimeRange: {
    start: '',
    end: ''
  }
};
import { cloneDeep } from 'lodash';
import setRules from '@/libs/rules';
import { citys } from '@/const/citys';
var rule = [{
  key: 'consigneeName',
  name: '客户姓名'
}, {
  key: 'consigneeDetails',
  name: '详细地址'
}, {
  key: 'consigneePhone',
  name: '手机号',
  validator: 'validatePhone'
}, {
  key: 'imageUrl',
  name: '图片'
}, {
  key: 'reason',
  name: '原因'
}, {
  key: 'toTime',
  name: '时间'
}];
export default {
  data: function data() {
    var _this = this;

    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'orders',
        params: cloneDeep(initForm),
        parser: function parser(res) {
          _this.records = res.records;
          return res;
        }
      },
      layer: {
        show: false,
        title: '',
        showButton: true,
        form: {},
        rules: setRules(rule)
      },
      active: {},
      nowIndex: -1,
      records: []
    };
  },
  methods: {
    handleSelectionChange: function handleSelectionChange() {},
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      if (this.layer.form.imageUrl.length > 4) return this.$message.error('最多上传五张图片');

      if (this.nowIndex >= 0) {
        this.layer.form.imageUrl[this.nowIndex] = this.VUE_APP_IMG_BASE + response.key;
        this.$forceUpdate();
      } else {
        this.layer.form.imageUrl.push(this.VUE_APP_IMG_BASE + response.key);
      }

      console.log('1111', this.layer.form.imageUrl);
      this.$refs['layerForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    handlClick: function handlClick(index) {
      this.nowIndex = index;
      console.log('index', index);
    },
    clickLayer: function clickLayer(item, row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.getQiNiu();

              case 2:
                _this2.active = _objectSpread(_objectSpread({}, item), row);
                _this2.layer.form = _objectSpread(_objectSpread({}, row), {}, {
                  imageUrl: []
                });
                _this2.layer.show = true;
                _this2.layer.title = item.title;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    confirm: function confirm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this3.active.type == 'updateConsignee')) {
                  _context4.next = 4;
                  break;
                }

                _this3.$refs.layerForm.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 6;
                              break;
                            }

                            citys.forEach(function (e) {
                              if (_this3.layer.form.consigneeProvince == e.label.split('市')[0] || e.label.split('省')[0] || e.label.split('壮族自治区')[0]) {
                                _this3.$set(_this3.layer.form, 'provinceCode', e.value);

                                e.children.forEach(function (_e) {
                                  if (_e.label == _this3.layer.form.consigneeCity) {
                                    _this3.$set(_this3.layer.form, 'cityCode', _e.value);

                                    _e.children.forEach(function (__e) {
                                      if (__e.label == _this3.layer.form.consigneeDistrict) {
                                        _this3.$set(_this3.layer.form, 'districtCode', __e.value);
                                      }
                                    });
                                  }
                                });
                              }
                            });
                            _context2.next = 4;
                            return _this3.$api[_this3.active.type]({
                              consigneeInfo: _objectSpread({}, _this3.layer.form),
                              orderId: _this3.active.orderId
                            });

                          case 4:
                            _this3.$notify.success({
                              title: '成功',
                              message: '修改成功'
                            });

                            _this3.layer.show = false;

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                _context4.next = 12;
                break;

              case 4:
                if (!(_this3.active.type == 'overdueDelivery')) {
                  _context4.next = 8;
                  break;
                }

                _this3.$refs.layerForm.validate( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                    var params;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!valid) {
                              _context3.next = 6;
                              break;
                            }

                            params = {
                              orderId: _this3.active.orderId,
                              toTime: _this3.layer.form.toTime,
                              reason: _this3.layer.form.reason,
                              imageUrl: _this3.layer.form.imageUrl
                            };
                            _context3.next = 4;
                            return _this3.$api[_this3.active.type](params);

                          case 4:
                            _this3.$notify.success({
                              title: '成功',
                              message: '修改成功'
                            });

                            _this3.layer.show = false;

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

                _context4.next = 12;
                break;

              case 8:
                _context4.next = 10;
                return _this3.$api[_this3.active.type](_objectSpread(_objectSpread({}, _this3.layer.form), {}, {
                  orderId: _this3.active.orderId
                }));

              case 10:
                _this3.$notify.success({
                  title: '成功',
                  message: '修改成功'
                });

                _this3.layer.show = false;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.layer.form, 'consigneeProvince', e[0]);
      e[1] && this.$set(this.layer.form, 'consigneeCity', e[1]);
      e[2] && this.$set(this.layer.form, 'consigneeDistrict', e[2]);
      e[0] && this.$set(this.active, 'consigneeProvince', e[0]);
      e[1] && this.$set(this.active, 'consigneeCity', e[1]);
      e[2] && this.$set(this.active, 'consigneeDistrict', e[2]);
      this.$refs.layerForm.validateField('consigneeProvince');
    },
    download: function download() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var columns, data, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                columns = [{
                  label: '订单号',
                  prop: 'orderId'
                }, {
                  label: '商品ID',
                  prop: 'goodsNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '订购数量',
                  prop: 'goodsCount'
                }, {
                  label: '下单时间',
                  prop: 'orderTime'
                }, {
                  label: '要炼价',
                  prop: 'goodsAmount'
                }, {
                  label: '订单金额',
                  prop: 'orderAmount'
                }, {
                  label: '结算金额',
                  prop: 'orderAmount'
                }, {
                  label: '余额支付',
                  prop: 'balancePay'
                }, {
                  label: '应付金额',
                  prop: 'orderAmount'
                }, {
                  label: '订单状态',
                  prop: 'orderStatus'
                }, {
                  label: '下单帐号',
                  prop: 'nickname'
                }, {
                  label: '客户姓名',
                  prop: 'consigneeName'
                }, {
                  label: '客户地址',
                  prop: 'consigneeAddress'
                }, {
                  label: '联系电话',
                  prop: 'consigneePhone'
                }, {
                  label: '订单备注',
                  prop: 'buyerRemark'
                }, {
                  label: '发票类型',
                  prop: 'invoiceType'
                }, {
                  label: '发票抬头',
                  prop: 'invoiceTitle'
                }, {
                  label: '发票内容',
                  prop: 'invoiceContent'
                }, {
                  label: '纳税人识别号',
                  prop: 'taxpayerIdNumber'
                }, {
                  label: '名称（个人）',
                  prop: 'invoiceTitleType'
                }, {
                  label: '单位地址',
                  prop: 'taxpayerAddress'
                }, {
                  label: '单位电话',
                  prop: 'taxpayerPhone'
                }, {
                  label: '开户银行',
                  prop: 'invoiceBankName'
                }, {
                  label: '银行账号',
                  prop: 'invoiceBankAccount'
                }, {
                  label: '商家备注',
                  prop: 'storeRemark'
                }, {
                  label: '商家备注等级（等级1-5为由高到低）',
                  prop: 'storeRemarkLevel'
                }, {
                  label: '运费金额',
                  prop: 'deliveryAmount'
                }, {
                  label: '付款确认时间',
                  prop: 'payTime'
                }, {
                  label: '货号',
                  prop: 'goodsModel'
                }, {
                  label: '订单完成时间',
                  prop: 'completeTime'
                }];
                data = [];
                _context6.next = 4;
                return _this4.$api.exportOrders(_objectSpread(_objectSpread({}, _this4.form), {}, {
                  pageSize: 999999
                }));

              case 4:
                res = _context6.sent;
                res.records.forEach( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(v) {
                    var goodsParams, params, orderStatusStr;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            goodsParams = {};
                            v.goodsItemList.forEach(function (e) {
                              goodsParams = _objectSpread({}, e);
                            });
                            params = {};
                            params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, v), v.consigneeInfo), v.invoiceInfo), goodsParams);

                            _this4.$set(params, 'consigneeAddress', v.consigneeInfo.consigneeProvince + v.consigneeInfo.consigneeCity + v.consigneeInfo.consigneeDistrict + v.consigneeInfo.consigneeDetails);

                            orderStatusStr = _this4.dict.orderStatus.filter(function (e) {
                              return e.value == v.orderStatus;
                            });

                            _this4.$set(params, 'orderStatus', orderStatusStr[0].label);

                            _this4.$set(params, 'invoiceType', v.invoiceType == 1 ? '普通电子发票' : v.invoiceType == 2 ? '增值税专用发票' : v.invoiceType == 3 ? '不开发票' : '');

                            _this4.$set(params, 'invoiceContent', v.invoiceInfo.invoiceContent == 1 ? '商品明细' : v.invoiceInfo.invoiceContent == 2 ? '商品类型' : '');

                            _this4.$set(params, 'invoiceTitleType', v.invoiceInfo.invoiceTitleType == 1 ? '个人' : v.invoiceInfo.invoiceTitleType == 2 ? '公司' : '');

                            if (res.payWay === 3) {
                              _this4.$set(params, 'balancePay', res.orderAmount);
                            }

                            data.push(params);

                          case 12:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

                _this4.xlsxExport(columns, data, '待出库订单');

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};